import IconDownload from '@creditflowresearch/uilib/Icon/IconDownload';
import Spinner from '@creditflowresearch/uilib/Loader/Spinner';
import { useAskAiChatContext } from '@/creditflowresearch/application/AskAiChat/context/AskAiChatContext';
import { AskAiProduct } from '@/creditflowresearch/domain/vo/AskAiChat';
import styles from './askAiChat.module.scss';

interface IProductTableControlsProps {
  messageId: string,
  product: AskAiProduct,
}

const PRODUCT_LABELS: Record<AskAiProduct, string> = {
  abs: 'ABS',
  corp: 'Corporate',
};

const ProductTableControls = ({ messageId, product }: IProductTableControlsProps) => {
  const { exportData, isExporting } = useAskAiChatContext();
  const isLoading = isExporting(messageId, product);

  return (
    <div className={ styles.tableControls } data-test={ `askAiChatTableControls-${ product }` }>
      <button
        type="button"
        className={ styles.downloadButton }
        onClick={ () => exportData(messageId, product) }
        disabled={ isLoading }
        aria-label={ `Export ${ PRODUCT_LABELS[product] }` }
        data-test="askAiChatTableExport"
      >
        { isLoading ? <Spinner size="XS" color="currentColor" /> : <IconDownload size={ 12 } /> }
      </button>
    </div>
  );
};

export default ProductTableControls;
